(function() {
    var noConflictOnError = window.onerror;

    window.onerror = function(msg, url, lineNumber, charNumber, exc) {
        if(!fp.isUnloading && !(lineNumber === 0 || /Script error\.?/.test(msg))) {
            fpUtil.hideProgress(true);
            fpUtil.hideLoading(true);

            fp.ui.unblockUI({force: true});
            fp.__$freshop.removeClass('fp-freshop-loading');
        }

        //fp.logError(msg, null, url, lineNumber, charNumber, exc);
        //fpUtil.showError({message: 'Error processing your request', retryMessage: 'Please try again'}, fp.__$freshop.find('[data-role="modal-container"] .fp-request'));
        //return true;

        if(_.isFunction(noConflictOnError)) return noConflictOnError(msg, url, lineNumber, charNumber, exc);
    };

    //customize dateFns
    var dateFnsFormatDistance = dateFns.formatDistance,
        locales = fp.__locales,
        defaultLocale = 'en',
        currentLocale = defaultLocale,
        dateFnsTimeMap = {
            H: 'Hours',
            m: 'Minutes',
            s: 'Seconds',
            S: 'Milliseconds'
        };

    $.extend(dateFns, {
        format2: function(date, format, options) {
            options = _.getObject(options);
            if(locales && !_.isObject(options.locale)) {
                var locale = options.locale || currentLocale;
                if(_.isString(locale)) locale = locales[locale] || locales[currentLocale];
                options.locale = locale;
            }

            if(_.isString(date)) date = this.parse(date);
    
            //moment uses DD and YY, dateFns uses dd and yy
            format = this.getFormat(format);
            
            var value = '';
            try {
                value = S(this.format(date, format, options))
                    .replace('AM', 'am')
                    .replace('PM', 'pm').s;
            }
            catch(exc) {
                fp.notifier.notify(exc, {
                    severity: 'error',
                    metaData: {
                        'meta data': {
                            'date': date
                        }
                    }
                });
            }

            return value;
        },
        getFormat: function(format, dateString) {
            //transform moment.js format into dateFns v2 format https://git.io/fxCyr
            //example, moment uses DD and YY, dateFns uses dd and yy
            if(!format) format = fp.serverDateTimeFormat;
            if(dateString && dateString.length < format.length) {
                format = format.substr(0, dateString.length - 1);
            }

            return S(format)
                .replaceAll('dddd', 'eeee')
                .replaceAll('ddd', 'eee')
                .replaceAll('D', 'd')
                .replaceAll('Y', 'y').s;
        },
        locale: function(locale) {
            if(fpUtil.isDefined(locale)) {
                currentLocale = (_.has(locales, locale) && locale) || defaultLocale;
            }
            else return currentLocale;
        },
        months: function(format, iteratee) {
            format = format || 'MMMM';
            var date = new Date(),
                months = [],
                month;

            _.times(12, function(n) {
                date.setMonth(n, 1);
                month = dateFns.format2(date, format);
                months.push(month);
                if(iteratee) iteratee(month, n);
            });

            return months;
        },
        utc: function(date) {
            if(!_.isDate(date)) date = new Date();

            return new Date(
                date.getUTCFullYear(),
                date.getUTCMonth(),
                date.getUTCDate(),
                date.getUTCHours(),
                date.getUTCMinutes(),
                date.getUTCSeconds(),
                date.getUTCMilliseconds()
            );
        },
        distanceFormat: function(dirtyDateLeft, dirtyDateRight, format) {
            format = S.getString(format);
            if(!(_.isDate(dirtyDateLeft) && _.isDate(dirtyDateRight))) {
                return format;
            }

            var self = this,
                matchDurationFormat = fpUtil.regExp.matchDurationFormat,
                times = {
                    Hours: 0,
                    Minutes: 0,
                    Seconds: 0,
                    Milliseconds: 0
                },
                returnValue,
                timeKey,
                time;

            _.each(times, function(value, key) {
                times[key] = value = self['differenceIn' + key](dirtyDateLeft, dirtyDateRight).toString();
                dirtyDateLeft = self['sub' + key](dirtyDateLeft, value);
            });

            matchDurationFormat.lastIndex = 0;
            format = format.replace(matchDurationFormat, function(value) {
                returnValue = value;
                timeKey = dateFnsTimeMap[value[0]];
                time = timeKey ? times[timeKey] : null;
                if(time != null) {
                    returnValue = time;
                    if (value.length > 1 && time.length < value.length) {
                        _.times(value.length - time.length, function(n){
                            returnValue = '0' + returnValue;
                        });
                    }
                }

                return returnValue;
            });

            return format;
        },
        formatDistance: function(dateToCompare, date, options) {
            if(_.isString(dateToCompare)) dateToCompare = this.parse(dateToCompare);
            if(_.isString(date)) date = this.parse(date);

            var value = '';

            try {
                value = S.getString(dateFnsFormatDistance.call(this, dateToCompare, date, options))
                    .replace('less than ', 'about ')
                    .replace('almost ', 'about '); 
            }
            catch(exc) {
                fp.notifier.notify(exc, {
                    severity: 'error',
                    metaData: {
                        'meta data': {
                            'dateToCompare': dateToCompare,
                            'date': date
                        }
                    }
                });
            }

            return value;
        }
    });

    var oldNumeralSet = numeral.fn.set;
    numeral.fn.set = function(value) {
        return oldNumeralSet.call(this, fpUtil.getFloat(value));
    };

    numeral.fn.round = function(precision) {
        precision = fpUtil.getInteger(precision);

        var value = this._value,
            places = value.toString().split('.')[1];

        if(places) {
            places = places.length;
            var multiple = '1';
            for(var n=0;n<places;n++) {
                multiple += '0';
            }
            multiple = parseInt(multiple, 10);
            this._value = parseFloat((Math.ceil(value * multiple) / multiple).toFixed(precision));
        }

        return this;
    };

    fp.numeralInstance = numeral();

    //for lack of a better location place Showdown extension here
    showdown.extension('newline', function() {
        return [{
            type: 'lang',
            filter: function(text) {
                return text.replace(/(^|[^\n])\n(?!\n)/gm, function(value) {
                    value = S(value);
                    if(!value.trim().s) return value.s;
                    return value.trimRight().s + '  \n';
                });
            }
        }];
    });

    showdown.extension('targetlink', function() {
        return [{
            type: 'lang',
            regex: /\[((?:\[[^\]]*]|[^\[\]])*)]\([ \t]*<?(.*?(?:\(.*?\).*?)?)>?[ \t]*((['"])(.*?)\4[ \t]*)?\)\{\:target=(["'])(.*?)\6}/g,
            replace: function(wholematch, linkText, url, a, b, title, c, target) {

                var result = '<a href="' + url + '"';

                if (typeof title != 'undefined' && title !== '' && title !== null) {
                    title = title.replace(/"/g, '&quot;');
                    title = showdown.helper.escapeCharacters(title, '*_', false);
                    result += ' title="' + title + '"';
                }

                if (typeof target != 'undefined' && target !== '' && target !== null) {
                    result += ' target="' + target + '"';
                }

                result += '>' + linkText + '</a>';
                return result;
            }
        }];
    });

    fp.markdownConverter = new showdown.Converter({extensions: ['newline', 'targetlink']});

    $.extend(fp.markdownConverter, {
        makePhoneHtml : function(text) {
            return fpUi.getMobilePhoneHtml(this.makeHtml(text));
        },
        makePlainText: function(text) {
            return S(text).replace(/[\][=~`#|()*_-]/g, '').s;
        }
    });

    Lockr.prefix = 'fp';

    $.extend($.blockUI.defaults, {
        message: ' \
            <div class="fp-placeholder" data-role="placeholder"> \
                <div class="sk-three-bounce"> \
                    <div class="sk-child sk-bounce1"></div> \
                    <div class="sk-child sk-bounce2"></div> \
                    <div class="sk-child sk-bounce3"></div> \
                </div> \
            </div> \
        ',
        centerY: false,
        centerX: false,
        css: {
            cursor: 'default',
            width: '100%',
            'pointer-events': 'none'
        },
        baseZ: 9999,
        showOverlay: false,
        focusInput: false,
        ignoreIfBlocked: true,
        fadeIn: 0,
        fadeOut: 0
    });

    $.extend(fp, {
        on: function(event, callback) {
            if (_.isFunction(callback) && (
                (fp.initialized && event == fp.events.INITIALIZED) ||
                (fp.loaded && event == fp.events.LOADED)
            )) {
                _.defer($.proxy(callback, this, $.Event(event)));
            }
            else {
                $(this).on(event, callback);
            }

            return this;
        }
        ,one: function(event, callback) {
            if (_.isFunction(callback) && (
                (fp.initialized && event == fp.events.INITIALIZED) ||
                (fp.loaded && event == fp.events.LOADED)
            )) {
                _.defer($.proxy(callback, this, $.Event(event)));
            }
            else {
                $(this).one(event, callback);
            }

            return this;
        }
        ,off: function(event, callback) {
            $(this).off(event, callback);

            return this;
        }
        ,trigger: function(event, data, selector, enableClientParams) {
            if(!event) return;

            var eventObj;
            if(_.isObject(event)) {
                eventObj = event;
                event = fpUtil.getEventNs(eventObj);
            }
            else eventObj = $.Event(event);

            if(enableClientParams && _.isObject(data)) {
                data.clientParams = _.getObject(data.clientParams);
                data.clientParams.promises = _.getArray(data.clientParams.promises);
            }

            if (this.Component) this.Component.trigger(selector, eventObj, data);

            //if a selector is available
            //only trigger event for selector
            if (selector) {
                // fp.log('Selector exists, triggering component scope event only.', selector, event, data);
                return eventObj;
            }
            $(fp).trigger(eventObj, data);
            $(fp.client).trigger(eventObj, data);

            return eventObj;
        }
        ,api: function(serviceCall, payload, options) {
            if (fp.isUnloading) return $.Deferred().promise();

            //if(!serviceCall) {
            //    fp.logStack(serviceCall, payload, options);
            //}
            //if(S(serviceCall).contains('stores')) {
            //    debugger;
            //}
            var errorHideMs = 400,
                ms = errorHideMs,
                apiMethods = fpConstants.apiMethods,
                httpStatus = fpConstants.httpStatus,
                uiRouter = fpUi.router,
                stateManager = uiRouter.stateManager,
                stateParams = stateManager.initialized ? stateManager.stateParams : uiRouter.routeManager.urlParams,
                retryOnFail;

            if (fp.__lastJsonRequestEndDate) ms = _.now() - fp.__lastJsonRequestEndDate.getTime();

            //hide error when a request is made and there are no ongoing requests
            if (fp.loaded && ms >= errorHideMs && !_.size(fp.apiQueue)) fpUtil.hideError();

            if(fpUtil.isNull(options) && _.isString(payload)) {
                options = payload;
                payload = undefined;
            }

            payload = fpUtil.getValue(payload, {});
            options = fpUtil.getValue(options, {});
            if (_.isString(options)) options = {method: options};

            _.defaults(options, {
                apiKey: 'client',
                apiVersion: fp.apiVersion,
                // ,cache: false
                queue: false,
                method: apiMethods.GET,
                dataType: 'json',
                timeout: fpConstants.api.TIMEOUT
            });

            if(!fpConfig.enableMultiplex) {
                delete options.multiplexId;
                delete options.runMultiplex;
            }

            retryOnFail = options.retryOnFail;

            //fp.log(serviceCall, payload, options);

            serviceCall = S(serviceCall);

            if (options.apiKey) {
                if (options.apiKey === 'sdk') {
                    options.prepareJsonData = false;
                    if(!_.has(options, 'retryOnFail')) retryOnFail = true;
                }
                else if (fp.ui/* && !fpConfig.disableInitializeShopping*/) {
                    _.find(fp.storeRequiredApis, function(value) {
                        if (!serviceCall.startsWith(value, true)) return;

                        if (!payload.store_id && !fpConfig.disableInitializeShopping) {
                            payload.store_id = fp.store.id || fp.config.topShopStoreId || fp.topStore.id;
                        }

                        _.each(fp.defaultStoreRequiredApiParams, function(value, key) {
                            if (stateParams[key] && !_.has(payload, value)) payload[value] = stateParams[key];
                        });

                        return true;
                    });
                }
            }

            //temporarily assign apiBaseUrl #FO-1091
            var promiseInitBaseUrl;
            if(
                fpConfig.intent === 'admin' &&
                options.apiKey === 'client' &&
                options.method === apiMethods.GET &&
                !options.apiBaseUrl
            ) {
                promiseInitBaseUrl = fpUi.initApiBaseUrl(payload.store_id);
            }

            //show captcha challenge
            let promiseCaptcha;
            if(fp.enableCaptchaEnterprise && options.captchaRequired) {
                promiseCaptcha = fpUi.showRecaptchaChallenge()
                    .done(function(resp){
                        if(resp){
                            payload.captcha_response = resp;
                        }
                    });
            }

            return $.when(promiseInitBaseUrl, promiseCaptcha)
                .then(function() {
                    var url;

                    if (options.apiKey) {
                        var apiUrlKey = fpUtil.getStateValue(options.apiKey === 'sdk', 'assetBaseUrl', 'apiBaseUrl'),
                            apiBaseUrl = fp[apiUrlKey],
                            apiUrl = (options.multiplexId && !options.runMultiplex) ? '' : (options[apiUrlKey] || apiBaseUrl);

                        if(options.apiKey === 'sdk' && !options[apiUrlKey]) {
                            url = fp.assetCdnUrl + serviceCall.trimLeft('/').s;
                        }
                        else {
                            if(!_.has(payload, 'token')) payload.token = fp.session.token;
                            var apiVersion = options.apiVersion ? options.apiVersion + '/' : '';
                            url = fpUtil.formatString('{0}{1}{2}', apiUrl, apiVersion, serviceCall.s);
                        }
                    }
                    else url = serviceCall.s;

                    options.apiContext = options.apiContext || 'api';
                    if(!_.has(options, 'prepareJsonData')) {
                        options.prepareJsonData = (options.apiKey && options.dataType === 'json' && !options.runMultiplex);
                    }

                    window.apiCount = (window.apiCount || 0) + 1;
                    var pref = fp.getPrefCookie(),
                        deferred = $.Deferred(),
                        promise = deferred.promise();

                    fpUtil.ensureSort(payload);

                    if (fpUtil.isNull(payload.token)) delete payload.token;
                    if (options.apiKey && options.apiKey !== 'sdk' && !payload.app_key) {
                        payload.app_key = fp.appKey;
                    }

                    options.url = url;
                    options.data = !_.size(payload) && options.data ? options.data : payload;
                    options.method = options.method.toUpperCase();

                    //if(!fp.loaded && options.cacheDuringLoad && !_.has(options, 'cache') /*|| (!_.has(options, 'cache') && options.apiKey == 'client')*/) {
                    //    options.cache = true;
                    //    //options.cacheDuringLoad = true;
                    //}

                    var enableCache = (
                        options.cache &&
                        fp.enableCache &&
                        !options.runMultiplex &&
                        options.method === apiMethods.GET
                    );

                    if(options.method === apiMethods.GET) {
                        if(
                            options.enableRenderId &&
                            !_.has(payload, 'render_id')
                        ) {
                            payload.render_id = fp.renderId;
                        }

                        if(!options.cacheKey && !options.runMultiplex) {
                            //options.cacheKey = (window.btoa || fp.btoa)((url + $.param(payload, undefined, true)).toLowerCase());
                            //options.cacheKey = S.stripPunctuation((url + $.param(payload, undefined, true)).toLowerCase()).s;
                            options.cacheKey = fpUtil.cache.key(url + $.param(payload));
                        }
                    }
                    else {
                        if(!_.has(payload, 'referrer')) payload.referrer = location.href;
                        if(fp.loaded){
                            //change renderId for non-GET calls
                            fp.renderId = _.now();
                        }
                    }

                    if(options.multiplexId && !options.runMultiplex) {
                        var multiplexItem = fp.multiplexQueue[options.multiplexId];
                        if(!multiplexItem) multiplexItem = fp.multiplexQueue[options.multiplexId] = [];

                        multiplexItem.push({
                            options: options,
                            promise: promise
                        });

                        return promise;
                    }

                    if(options.cacheKey) {
                        if (enableCache) {
                            var cachedData = fpUtil.cache.get(options.cacheKey);
                            //fp.log('cachedData', (url + $.param(payload, undefined, true)).toLowerCase(), cachedData);
                            if (cachedData != null) {
                                return deferred
                                    .resolve(cachedData, null, null, options)
                                    .promise();
                            }
                        }

                        //removeIf(!debug)

                        // if (!fp.loaded && options.method == apiMethods.GET && (window.__performance || stateParams.log_cache_key == 'true')) {
                        //     var cachedData = window.__performance && __performance.cache[options.cacheKey],
                        //         sUrl = S(url);
                        //     //fp.log('cachedData', url, options.cacheKey, cachedData);

                        //     if (cachedData != null) {
                        //         return deferred
                        //             .resolve(cachedData, null, null, options)
                        //             .promise();
                        //     }
                        //     else if ((options.apiKey == 'client' || stateParams.deploy_id) && !sUrl.contains('/products/ads') && !sUrl.contains('/sessions')) {
                        //         var token = fp.session.token || fp.getSessionCookie().token;
                        //         fp.log(JSON.stringify(
                        //             [
                        //                 fpUtil.getApiUrl(url, payload, options.method, true).replace(apiBaseUrl, '/').replace(token, '[TOKEN]').replace(payload.app_key, '[APP_KEY]'),
                        //                 options.cacheKey.replace(token, '[TOKEN]').replace(payload.app_key, '[APP_KEY]')
                        //             ]) + ',');
                        //     }
                        // }

                        //endRemoveIf(!debug)
                    }

                    if (options.method == apiMethods.GET) {
                        //return active promise if it exists
                        if(!options.disableUseActivePromise && options.cacheKey) {
                            var activeItem = fp.apiQueue[options.cacheKey];
                            if (activeItem && activeItem.promise/* && activeItem.promise.state() == 'pending'*/) {
                                return activeItem.promise;
                            }
                        }
                    }
                    else if(!_.has(payload, 'utc') && options.apiKey) {
                        payload.utc = dateFns.utc().getTime();
                    }

                    if (options.apiKey) {
                        if ($.support.cors) options.type = options.method;
                        else options.dataType = 'jsonp';

                        //if (fp.isDev() && !_.has(payload, 'pretty')) payload.pretty = true;
                    }

                    if (options.dataType == 'jsonp') {
                        options.crossDomain = true;

                        if(options.method != apiMethods.GET) {
                            options.data._method = options.method;
                            options.method = apiMethods.GET;
                        }
                    }

                    if(fp.isDev()) {
                        var debug = pref.debug;
                        if (debug.error_code && debug.api && serviceCall.startsWith(debug.api, true)) {
                            payload.error_code = debug.error_code;

                            payload.spill = fpUtil.getBoolean(debug.spill, true);
                            payload.status_code = debug.status_code || httpStatus.BAD_REQUEST;
                        }

                        //if(payload.spill) {
                        //    payload.status_code = payload.status_code || httpStatus.BAD_REQUEST;
                        //    payload.error_code = payload.error_code || 'invalid_input';
                        //
                        //    //test error handling
                        //    var resp = {responseJSON: {error_message: 'A spill error has occurred', error_code: payload.error_code, status_code: payload.status_code}};
                        //    fail(resp);
                        //    return promise;
                        //}

                        //if(!window.test && S(fpUtil.getApiUrl(url, payload, options.method, true)).contains('fields=id&has_address=true&is_selectable=true&limit=1')) {
                        //    window.test = true;
                        //    options.timeout = 100;
                        //    //payload.spill = true;
                        //    //payload.hang_for = 5; //5 seconds
                        //}
                    }

                    if(options.enableListLoading) {
                        //fp.log(fpUtil.getApiUrl(url, payload, options.method, true), 'showLoading');
                        fpUtil.showLoading();
                    }

                    _.each(options, function(value, key) {
                        if(fpUtil.isNull(value)) delete options[key];
                    });

                    //if(options.queue) jqXHR = $.ajaxQueue(options);
                    //else jqXHR = $.ajax(options);

                    var requestStartDate = new Date();

                    if(!fp.loaded && !fp.apiTotalStartDate && options.apiKey == 'client') {
                        fp.apiTotalStartDate = requestStartDate;
                    }

                    function ajax() {
                        if (pref.log_jsonp) fp.log(fpUtil.getApiUrl(url, payload, options.method, true));

                        //keep a reference to original jsXHR so it can be aborted if necessary
                        var jqXHR = $.ajax(options);

                        //if(fp.isLocal() && window.testJsonEmpty) {
                        //    var temp = jqXHR;
                        //    jqXHR = jqXHR.then(function (resp, textStatus, jqXHR) {
                        //        delete window.testJsonEmpty;
                        //        delete options.dataFilter;
                        //        temp.responseText = '';
                        //        temp.responseJSON = {error_message: 'JSON parse error'};
                        //        return $.Deferred().reject(temp);
                        //    }, function (resp, textStatus, jqXHR) {
                        //        delete window.testJsonEmpty;
                        //        delete options.dataFilter;
                        //        temp.responseText = '';
                        //        temp.responseJSON = {error_message: 'JSON parse error'};
                        //        return $.Deferred().reject(temp);
                        //    });
                        //}

                        if(!fp.loaded && options.apiKey == 'client') {
                            fp.apiCallTotalCount = (fp.apiCallTotalCount || 0) + 1;
                        }

                        jqXHR
                            .then(
                                success,
                                fail
                            )
                            .always(function () {
                                if (fp.isUnloading) return;
                                fp.__lastJsonRequestEndDate = new Date();
                                fpUtil.hideLoading();
                                //fp.log(fpUtil.getApiUrl(url, payload, options.method, true), 'hideLoading');
                                //fp.trigger(fp.events.API_QUEUE_DELETED, {payload: payload, options: options, cacheKey: options.cacheKey});
                                if(options.cacheKey) delete fp.apiQueue[options.cacheKey];
                            });

                        if(options.cacheKey) {
                            fp.apiQueue[options.cacheKey] = {
                                apiContext: options.apiContext,
                                promise: promise
                            };
                        }
                        //fp.trigger(fp.events.API_QUEUE_ADDED, {payload: payload, options: options, cacheKey: options.cacheKey});

                        if (fp.initialized && !fp.loaded && !options.disableShowProgress) {
                            fpUtil.showProgress(promise);
                        }

                        return jqXHR;
                    }

                    function success(resp, textStatus, jqXHR) {
                        var scopeOptions = options,
                            scopePayload = payload,
                            scopeUrl = url,
                            isMultiplexItem = !!(textStatus && textStatus.promise),
                            multiplexItem;

                        if(isMultiplexItem) {
                            jqXHR = resp;
                            resp = resp.response;
                            multiplexItem = textStatus;
                            textStatus = '';
                            scopeOptions = multiplexItem.options;
                            scopePayload = scopeOptions.data;

                            var apiUrlKey = fpUtil.getStateValue(scopeOptions.apiKey == 'sdk', 'assetBaseUrl', 'apiBaseUrl'),
                                apiBaseUrl = fp[apiUrlKey];

                            scopeUrl = (scopeOptions[apiUrlKey] || apiBaseUrl) + scopeOptions.url;
                        }
                        else if(options.apiKey == 'client') {
                            var now = new Date(),
                                duration = now.getTime() - requestStartDate.getTime();

                            if(fpUtil.getBoolean(stateParams.log_api_duration, false)) {
                                fp.log('duration:', duration, fpUtil.getApiUrl(scopeUrl, scopePayload, scopeOptions.method, true));
                            }

                            if(!fp.loaded) {
                                fp.apiSumDuration = (fp.apiSumDuration || 0) + duration;
                                fp.apiTotalEndDate = now;
                            }
                        }

                        var status = jqXHR.status_code || jqXHR.status,
                            isRespNull = fpUtil.isNull(resp),
                            typeOfResp = typeof(resp);

                        //This is now handled via assetVersionService
                        //if (options.apiKey == 'sdk') {
                        //    if (!fp.isUnloading && (_.isObject(resp) && resp.reload === true) && fpUtil.getBoolean(stateParams.reload, false) !== true) {
                        //        var stateParamsCopy = $.extend({}, stateParams);
                        //        stateParamsCopy.reload = true;
                        //
                        //        // if(stateManager.current.abstract) {
                        //        //     fp.isUnloading = true;
                        //        //     fpUtil.routeUrlParams(stateParamsCopy);
                        //        //     window.location.reload();
                        //        // }
                        //        // else stateManager.go(stateManager.current, stateParamsCopy, {reload: true});
                        //
                        //        fp.isUnloading = true;
                        //        fpUtil.routeUrlParams(stateParamsCopy);
                        //        window.location.reload();
                        //
                        //        return $.Deferred().promise();
                        //    }
                        //}

                        //if(scopeUrl.indexOf('departments/1') >= 0) resp.error_message = 'An error has occurred';
                        //if(S(scopeUrl).endsWith('user_addresses')) isRespNull = true;

                        if ((_.isObject(resp) && resp.error_code) || !fpUtil.isApiResponseSuccess(status)) {
                            resp = _.getObject(resp);
                            return fail(jqXHR, textStatus, S.getString(resp.error_message, 'An error has occurred').s);
                        }
                        else {
                            if (scopeOptions.dataType == 'json') {
                                if (isRespNull || typeOfResp != 'object') {
                                    var errorMessage;

                                    if(isRespNull) errorMessage = 'ApiError: A null response was returned by api';
                                    else errorMessage = fpUtil.formatString('ApiError: A non-object ({0}) response was returned by api', typeOfResp);

                                    fp.notifier.notify({
                                        name: 'ApiError',
                                        message: errorMessage
                                    }, {
                                        severity: 'error',
                                        metaData: {
                                            'meta data': {
                                                Status: status,
                                                Duration: dateFns.distanceFormat(new Date(), requestStartDate, 'HH:mm:ss.SSS'),
                                                'API Url': fpUtil.getApiUrl(scopeUrl, scopePayload, scopeOptions.method, true),
                                                'Response Headers': _.isFunction(jqXHR.getAllResponseHeaders) ? jqXHR.getAllResponseHeaders() : '',
                                                Multiplex: isMultiplexItem ? true : undefined
                                            }
                                        }
                                    });
                                }
                            }

                            if (_.isObject(resp)) {
                                delete resp.status_code;

                                if (!scopeOptions.disableSetSession && resp.token) {
                                    fp.setSession({token: resp.token});
                                }

                                //if(serviceCall.eq('order_statuses') && fp.isDev()) {
                                //    _.removeWhere(resp.items, {identifier: 'open'});
                                //    _.removeWhere(resp.items, {identifier: 'user_placed'});
                                //}

                                //manually fix issue where api does not return open status when calling order_statuses
                                if (!fpConfig.disableInitializeShopping && serviceCall.s == 'order_statuses' && scopeOptions.method == apiMethods.GET && _.size(resp.items) > 1) {
                                    var orderStatus;
                                    _.each(['open', 'user_placed'], function (value) {
                                        if (_.findWhere(resp.items, {identifier: value})) return;

                                        switch (value) {
                                            case 'open':
                                                orderStatus = {
                                                    name: 'Open',
                                                    identifier: 'open',
                                                    id: '1'
                                                };
                                                break;
                                            case 'user_placed':
                                                orderStatus = {
                                                    name: 'Placed',
                                                    identifier: 'user_placed',
                                                    id: '2'
                                                };
                                                break;
                                            //no default
                                        }

                                        resp.items.push(orderStatus);

                                        fp.notifier.notify({
                                            name: 'OrderStatusError',
                                            message: fpUtil.formatString('OrderStatusError: "{0}" status not found in returned order_statuses. Manually adding "{0}" status', orderStatus.name)
                                        }, {
                                            severity: 'error',
                                            metaData: {
                                                'meta data': {
                                                    Status: status,
                                                    'API Url': fpUtil.getApiUrl(scopeUrl, scopePayload, scopeOptions.method, true),
                                                    Multiplex: isMultiplexItem ? true : undefined
                                                }
                                            }
                                        });
                                    });
                                }
                            }

                            if (scopeOptions.prepareJsonData) {
                                //currently client side JS will only auto sort (by sequence) if
                                //  1. sort is not passed to api via scopePayload.sort
                                //  2. sequence exists on objects in returned items array
                                if(!payload.sort) fpUtil.prepareJsonData(resp, {name: 'sequence', value: 'asc'});
                            }

                            if (scopeOptions.cacheKey && enableCache) {
                                var expiry = fpUtil.isNumeric(scopeOptions.cache) ? scopeOptions.cache : -1;
                                fpUtil.cache.set(scopeOptions.cacheKey, resp, expiry);
                            }
                        }

                        if(isMultiplexItem) {
                            multiplexItem.promise.deferred().resolve(resp, textStatus, jqXHR, scopeOptions);
                        }
                        else {
                            var multiplexFail;
                            if(options.multiplexId) {
                                var multiplexResp;
                                _.each(fp.multiplexQueue[options.multiplexId], function(item) {
                                    multiplexResp = _.getObject(resp[item.key]);
                                    if(multiplexResp.status == httpStatus.OK) success(multiplexResp, item);
                                    else {
                                        fail(multiplexResp, item);
                                        multiplexFail = true;
                                    }
                                });
                                delete fp.multiplexQueue[options.multiplexId];
                            }

                            if(multiplexFail) deferred.reject(jqXHR, 'fail', 'fail', options);
                            else deferred.resolve(resp, textStatus, jqXHR, options);
                        }
                    }

                    function fail(jqXHR, textStatus, errorThrown) {
                        if(fp.isUnloading) return $.Deferred().promise();
                        if(textStatus == 'abort') return;

                        var scopeOptions = options,
                            scopePayload = payload,
                            scopeUrl = url,
                            isMultiplexItem = !!(textStatus && textStatus.promise),
                            multiplexItem;

                        if(isMultiplexItem) {
                            multiplexItem = textStatus;
                            textStatus = '';
                            scopeOptions = multiplexItem.options;
                            scopePayload = scopeOptions.data;

                            var apiUrlKey = fpUtil.getStateValue(scopeOptions.apiKey == 'sdk', 'assetBaseUrl', 'apiBaseUrl'),
                                apiBaseUrl = fp[apiUrlKey];

                            scopeUrl = (scopeOptions[apiUrlKey] || apiBaseUrl) + scopeOptions.url;
                        }

                        jqXHR = _.getObject(jqXHR);
                        jqXHR.durationMs = dateFns.differenceInMilliseconds(new Date(), requestStartDate);

                        if(scopeOptions.method != apiMethods.GET && !scopeOptions.data._method) {
                            scopeOptions.data._method = scopeOptions.method;
                        }

                        if(errorThrown == 'error') errorThrown = undefined;

                        var resp = fpUtil.getXhrErrorResponse(jqXHR, textStatus, errorThrown),
                            apiStatus = resp.status_code || jqXHR.status || 0,
                            status = fpUtil.getApiResponseStatus(resp, textStatus, jqXHR, options),
                            apiUrl = fpUtil.getApiUrl(scopeUrl, scopePayload, scopeOptions.method, true),
                            errorMessage = S.getString(resp.error_message, resp.error_code),
                            errorType = 'ApiError',
                            isAd = scopeOptions.url.match(/banner-ads?/i),
                            disableErrorNotify,
                            responseText;

                        if(isAd) {
                            isAd = true;
                        }

                        //fp.log('resp', resp, 'jqXHR', jqXHR);
                        //fp.log('status', status, 'apiStatus', apiStatus, ' resp.status_code', resp.status_code, 'jqXHR.status', jqXHR.status);

                        //if status == 0 it is most likely a connectivity issue but only report if window.navigator.onLine === false
                        if(status == 0 && window.navigator.onLine === false) {
                            //when textStatus == 'error' and status == 0 (jQuery >= 3) or status == 404 (jQuery < 3) this may be an indicator of a client connection issue
                            errorType = 'ConnectivityError';
                            errorMessage = 'connectivity error';
                        }
                        else if(status == httpStatus.GATEWAY_TIMEOUT) {
                            if(
                                !apiStatus &&
                                (jqXHR.durationMs < fpConstants.api.TIMEOUT || jqXHR.durationMs > fpConstants.api.TIMEOUT + 1000)
                            ) {
                                //client side timed out based on this request's allowed milliseconds (used in sponsored ads)
                                errorType = 'AbortError';
                                errorMessage = 'abort';
                                status = 0;

                                //don't notify for excessive duration
                                if(jqXHR.durationMs > fpConstants.api.TIMEOUT + 1000) {
                                    disableErrorNotify = true;
                                }
                            }
                            else { //server side timeout
                                errorType = 'TimeoutError';
                            }
                        }


                        if(isAd && !status) {
                            retryOnFail = false;
                            scopeOptions.ignoreErrors = true;
                        }
                        else if(
                            !isMultiplexItem &&
                            options.apiKey &&
                            options.cache !== false &&
                            options.method == apiMethods.GET &&
                            status != httpStatus.BAD_REQUEST &&
                            _.has(jqXHR, 'readyState') &&
                            S(errorMessage).contains('JSON')
                        ) {
                            responseText = jqXHR.responseText;
                            if(!fpUtil.isNull(responseText)) {
                                var text = S.getString(responseText);
                                responseText = text.substring(0, 400);
                                if(responseText.length < text.length) responseText += '...';
                            }

                            if(!responseText && !_.has(options, 'retryOnFail')) {
                                retryOnFail = true;
                            }
                        }

                        if(!disableErrorNotify && status != httpStatus.BAD_REQUEST) {
                            fp.notifier.notify({
                                name: errorType,
                                message: fpUtil.formatString('{0}: A {1}error has occurred ({2})', errorType, fpUtil.getStateValue(status && !fpUtil.isApiResponseSuccess(status), status + ' ', ''), errorMessage)
                            }, {
                                severity: 'error',
                                metaData: {
                                    'meta data': {
                                        Status: fpUtil.getStateValue(status, status, ''),
                                        Duration: dateFns.distanceFormat(new Date(), requestStartDate, 'HH:mm:ss.SSS'),
                                        'API Url': apiUrl,
                                        'Response Headers': _.isFunction(jqXHR.getAllResponseHeaders) ? jqXHR.getAllResponseHeaders() : '',
                                        'Response Text': responseText
                                    }
                                }
                            });
                        }
                        else if(!fp.isProd()) fp.logError(errorMessage, status || '', apiUrl);

                        if(retryOnFail && status != httpStatus.NOT_FOUND) {
                            retryOnFail = false;
                            if(options.method == apiMethods.GET) options.cache = false;

                            //delete options.data.spill;
                            //if(fp.isLocal()) delete scopeOptions.data.spill;

                            var deferredRetry = $.Deferred(),
                                delay = 300;

                            fp.warn(fpUtil.formatString('Request failed {0} ({1}). Retrying after {2}ms', apiUrl, errorMessage, delay));

                            _.delay(deferredRetry.resolve, delay);

                            return deferredRetry
                                .then(ajax)
                                .promise();
                        }

                        var promiseFail;

                        switch (resp.error_code) {
                            case 'sign_out_required':
                                if(fp.isDev()) debugger;
                                if(!options.disableSignOut) {
                                    promiseFail = fp.handleSignOutRequired(resp.error_message, false, status, apiUrl);
                                }
                                break;
                            case 'sign_in_required':
                                if(fp.isDev()) debugger;
                                if(!options.disableSignOut) {
                                    promiseFail = fp.handleSignInRequired(resp.error_message);
                                }
                                break;
                            case 'order_mismatch':
                                var ignoreErrors = scopeOptions.ignoreErrors;
                                if(ignoreErrors) ignoreErrors = (_.isArray(ignoreErrors) || _.isBoolean(ignoreErrors)) ? ignoreErrors : [ignoreErrors];
                                if(ignoreErrors !== true && !_.contains(ignoreErrors, resp.error_code)) {
                                    if(!ignoreErrors) ignoreErrors = [];
                                    ignoreErrors.push(resp.error_code);
                                    scopeOptions.ignoreErrors = ignoreErrors;
                                    promiseFail = fp.clearOrderPreference(null, resp.error_code, resp.error_message);
                                }
                                break;
                            case 'captcha_required':
                                if(!fp.enableCaptchaEnterprise) {
                                    if(_.isBoolean(ignoreErrors)) ignoreErrors = null;
                                    if(ignoreErrors) ignoreErrors = _.isArray(ignoreErrors) ? ignoreErrors : [ignoreErrors];
                                    if(retryOnFail !== false && !_.contains(ignoreErrors, resp.error_code)) {        
                                        retryOnFail = false;
                                        if(!ignoreErrors) ignoreErrors = [];
                                        ignoreErrors.push(resp.error_code);
                                        scopeOptions.ignoreErrors = ignoreErrors;

                                        if(!fp.__handleCaptchaReady) {
                                            var deferredRetry = $.Deferred();

                                            fp.__handleCaptchaReady = function () {
                                                fp.one(fp.events.INITIALIZED, function () {
                                                    let promiseVerify;
                                                    if(fp.grecaptchaReady !== false) {
                                                        promiseVerify = fpUi.verifyRecaptcha(/*{
                                                            spill: true,
                                                            error_code: 'invalid_operation',
                                                            status_code: 400
                                                        }*/);
                                                    }

                                                    $.when(promiseVerify)
                                                        .always(function (data) {
                                                            delete fp.__handleCaptchaReady;

                                                            if (data?.token) deferredRetry.resolve();
                                                            else deferredRetry.reject(jqXHR, textStatus, errorThrown, options);
                                                        });
                                                });
                                            };
                                            
                                            if (fp.grecaptchaReady) {
                                                fp.__handleCaptchaReady();
                                            }
                                            else {
                                                fp.one(fp.events.CAPTCHA_READY, fp.__handleCaptchaReady);
                                                if(!fp.loaded || fp.grecaptchaReady === false) {
                                                    fpUi.initRecaptcha();
                                                }
                                            }
                                            
                                            return deferredRetry
                                                .then(ajax, fail)
                                                .promise();
                                        }
                                    }
                                }
                                break;
                            default:
                                break;
                        }

                        $.when(promiseFail)
                            .always(function() {
                                var error = _.getObject(fpUtil.handleApiError(resp, textStatus, jqXHR, options));
                                //fp.log(jqXHR, textStatus, error.html, options);

                                if(isMultiplexItem) {
                                    multiplexItem.promise.deferred().reject(jqXHR, textStatus, error.html, scopeOptions);
                                }
                                else {
                                    if (options.multiplexId) {
                                        _.each(fp.multiplexQueue[options.multiplexId], function (item) {
                                            item.promise.deferred().reject(jqXHR, textStatus, error.html, options);
                                        });
                                        delete fp.multiplexQueue[options.multiplexId];
                                    }

                                    deferred.reject(jqXHR, textStatus, error.html, options);
                                }
                            });
                    }

                    var jqXHR = ajax();

                    deferred
                        .fail(function (statusText) {
                            if (statusText == 'abort' && _.has(jqXHR, 'abort')) {
                                jqXHR.abort(statusText);
                            }
                        });

                    return promise;
                });
        }
        ,init: function(config, token, delay) {
            //removeIf(!debug)

            //fp.log(fpUtil.formatString(
            //    'UI Init Called At: {0}s',
            //    fp.numeralInstance.set(dateFns.differenceInMilliseconds(new Date(), fp.loadStartDate) / 1000).format('#,0.0##')
            //));
            //
            //var urlParams = fpUi.router.routeManager.urlParams;
            //delay = fpUtil.isNull(delay) && urlParams.init_hang_for ? true : delay;
            //
            //if(delay) {
            //    if(!fpUtil.isInteger(delay)) {
            //        delay = fpUtil.getInteger(urlParams.init_hang_for);
            //    }
            //    if(delay) {
            //        fp.warn('Delaying fp.init for ' + delay + 'ms');
            //        _.delay($.proxy(this.init, this, config, token, false), delay);
            //        return;
            //    }
            //}

            //endRemoveIf(!debug)

            delete window.fp;

            //assign global variables that need to be set after loading additional js
            fpUi = fp.ui;

            if (this.initializing || this.initialized) return;
            this.initializing = true;

            //token may be passed in from client
            if(token) fp.setSessionCookie({token: token});

            if(window.performance && performance.timing) fp.loadStartDate = new Date(performance.timing.requestStart);

            if(_.isFunction(fp.initUI)) fp.initUI(config);
            else {
                this.initSession(true)
                    .done(function() {
                        fp.loaded = true;
                        freshop.loaded = true;

                        fp.log('Freshop loaded');
                        fp.trigger(fp.events.LOADED);

                        fp.trigger(fp.events.STORE_CHANGED, (fp.store.id ? fp.store : {}));
                    });
            }
        }
        ,initSession: function(initUser, fromInitLogin) {
            initUser = fpUtil.getBoolean(initUser, false);
            fromInitLogin = fpUtil.getBoolean(fromInitLogin, false);

            var sessionCookie = fp.getSessionCookie(),
                token = sessionCookie.token,
                deferredInit = $.Deferred(),
                locale = fpConfig.enableLocale && fp.locale,
                isImpersonate = sessionCookie.impersonate,
                promiseSession,
                stateManager = fp.ui.router.stateManager;

            //temporarily assign apiBaseUrl #FO-1091
            if(fpConfig.intent === 'admin' && fpConfig.enableInitApiBaseUrl && !fp.__defaultApiBaseUrl) {
                if(!fp.__onSessionChanged) {
                    fp.__onSessionChanged = function(event, payload) {
                        const sessionCookie = fp.getSessionCookie(),
                            cookiePayload = {};
    
                        payload = _.getObject(payload);
                        if(payload.oldSession.token) {
                            if(sessionCookie.token_default === payload.oldSession.token) {
                                cookiePayload.token_default = payload.session.token;
                            }
        
                            if(sessionCookie.token === payload.oldSession.token) {
                                cookiePayload.token = payload.session.token;
                            }
                            else if(sessionCookie.token_gcp === payload.oldSession.token) {
                                cookiePayload.token_gcp = payload.session.token;
                            }
                        }
    
                        fp.setSessionCookie(cookiePayload);
                    }
                }

                fp.off(fp.events.SESSION_CHANGED, fp.__onSessionChanged);
                fp.on(fp.events.SESSION_CHANGED, fp.__onSessionChanged);

                fp.__defaultApiBaseUrl = fp.apiBaseUrl;

                if(token) {
                    if(token !== sessionCookie.token_default && token !== sessionCookie.token_gcp) {
                        token = sessionCookie.token_default;
                        fp.setSessionCookie({
                            token: token,
                            api_base_url: fp.__defaultApiBaseUrl
                        });
                    }
                    else if(token === sessionCookie.token_gcp && sessionCookie.api_base_url && sessionCookie.api_base_url !== fp.__defaultApiBaseUrl) {
                        token = sessionCookie.token_gcp;
                        fp.apiBaseUrl = sessionCookie.api_base_url;
                    }
                }
            }

            if(token) {
                const payload = {id: token, token: null};
                if(stateManager.current == stateManager.states.account || stateManager.current.parent == stateManager.states.account) {
                    payload.perform_reverse_sync = true;
                }

                fpUtil.initAndApplyTransend(payload, fromInitLogin);

                promiseSession = fpService.sessionService
                    .get(payload, {
                        handleErrors: false,
                        ignoreErrors: 'sign_out_required',
                        formatForRestfulId: true
                    });

                //if(!fpUtil.routeUrlParams().error) {
                //    payload.spill = true;
                //    payload.status_code = fpConstants.httpStatus.BAD_REQUEST;
                //    payload.error_code = 'sign_out_required';
                //}
            }
            else {
                promiseSession = fpService.sessionService
                    .create({
                        locale: fpUtil.getUndefinedIfEmpty(locale),
                        token: null
                    });
            }

            promiseSession
                .then(function(resp) {
                    if(locale && resp.locale != locale && (!resp.is_user_logged_in || isImpersonate)) {
                        var oldLoggedIn = resp.is_user_logged_in,
                            oldToken = resp.token;
                        return fpService.sessionService
                            .update({
                                id: oldToken,
                                locale: locale
                            }, {
                                handleErrors: false
                            })
                            .then(function(resp) {
                                if(!_.has(resp, 'token')) resp.token = resp.id || oldToken;
                                if(!_.has(resp, 'is_user_logged_in')) resp.is_user_logged_in = oldLoggedIn;
                                return resp;
                            });
                    }

                    return resp;
                })
                .done(success)
                .fail(function(jqXHR, textStatus, errorThrown) {
                    var resp = fpUtil.getXhrErrorResponse(jqXHR),
                        httpStatus = fpConstants.httpStatus,
                        status = resp.status_code || jqXHR.status;

                    if(status == httpStatus.BAD_REQUEST) {
                        if(fp.isUnloading) return;

                        if (resp.error_code == 'sign_out_required') {
                            return fp.handleSignOutRequired(resp.error_message, true, status, fpUtil.getApiUrl('sessions', payload, options.method, true))
                                .done(function () {
                                    fpService.sessionService.create().done(success);
                                });
                        }
                        else fpService.sessionService.create().done(success);
                    }

                    fpUtil.handleApiError(resp, textStatus, jqXHR);

                    deferredInit.reject(jqXHR, textStatus, errorThrown);
                });

            function success(resp) {
                //sessionInitialized is used to determine if session has been initialized
                //for current browser request
                fp.sessionInitialized = true;
                resp.token = S.getString(resp.token, token);
                fp.setSession(resp, true);

                //temporarily assign apiBaseUrl #FO-1091
                if(fpConfig.intent === 'admin' && fp.apiBaseUrl === fp.__defaultApiBaseUrl) {
                    fp.setSessionCookie({token_default: fp.session.token});
                }

                var promiseLocale;
                if(locale) {
                    promiseLocale = fpUtil.map.load({
                        service: fpService.tagService,
                        payload: {
                            type: 'locale'
                        }
                    })
                    .then(function() {
                        _.each(fpUtil.map.get('locale').items(), function(item) {
                            item.value = item.identifier.replace('_', '-');
                        });
                    });
                }

                $.when(promiseLocale)
                    .done(function() {
                        if(initUser) {
                            var promiseUser;
                            if(fp.session.is_user_logged_in) {
                                promiseUser = fpService.userMeService
                                    .get()
                                    .then(function(resp) {
                                        //don't set user's locale if session is impersonated
                                        if(locale && resp.locale != locale && !isImpersonate) {
                                            return fpService.userMeService
                                                .update({
                                                    locale: locale
                                                }, {
                                                    handleErrors: false
                                                });
                                        }
                                        return resp;
                                    })
                                    .then(function(resp) {
                                        const user = resp;
                                        //temporarily assign apiBaseUrl #FO-1091
                                        if(fp.config.intent === 'admin') {
                                            if(fpUtil.isSuperUser(user)) {
                                                if(user.preference) {
                                                    _.empty(user.preference.last_used_store_ids);
                                                    if(fp.__envLastUsedStoreId) {
                                                        user.preference.last_used_store_ids = _.getArray(user.preference.last_used_store_ids);
                                                        user.preference.last_used_store_ids.push(fp.__envLastUsedStoreId);
                                                        return fpService.preferenceService
                                                            .update({last_used_store_ids: user.preference.last_used_store_ids})
                                                            .then(function() {
                                                                return user;
                                                            });
                                                    }
                                                }
                                            }
                                            else {
                                                const storeId = _.first(_.firstObject(user.authorizations).store_ids);
                                                if(storeId && user.preference) {
                                                    user.preference.last_used_store_ids = _.chain(user.preference.last_used_store_ids).getArray().empty().value();
                                                    user.preference.last_used_store_ids.push(storeId);
                                                }
                                                return fpUi.initApiBaseUrl(storeId, user)
                                                    .then(function() {
                                                        return user;
                                                    });
                                            }
                                        }
                                        return user;
                                    });
                            }

                            $.when(promiseUser)
                                .done(function(resp) {
                                    resp = resp || fp.user;
                                    fp.setUser(resp);                                    

                                    if(fp.session.is_user_logged_in && fp.user.user_status_identifier == 'registration_pending') {
                                        fp.warn(window.location.href);

                                        var stateManager = fpUi.router.stateManager,
                                            routeStates = fpConfig.routeStates;

                                        if (!stateManager.is(routeStates.accountCreate)) {
                                            stateManager.go(routeStates.accountCreate);

                                            if(!fpUi.router.location.isCurrentPage(stateManager.href(routeStates.accountCreate))) {
                                                return;
                                            }
                                        }
                                    }

                                    //if initializing session from URL token then ensure user's chosen locale
                                    //var uiRouter = fpUi.router;
                                    //if(uiRouter.routeManager.urlParams.token == fp.session.token) {
                                    //    var url = fpUi.applyUserLocaleToUrl();
                                    //    if (url && url != uiRouter.location.pathname(true)) {
                                    //        if (uiRouter.stateManager.go(url, null, {absolute: true})) return;
                                    //    }
                                    //}

                                    deferredInit.resolve();
                                    fp.trigger(fp.events.USER_LOADED, fp.user);
                                });
                        }
                        else {
                            deferredInit.resolve();
                        }
                    });

                if(!fp.initialized) {
                    //freshop initialized event needs to be bound before we trigger the initialized event
                    //setTimeout(function(){
                    //    fp.client.bindInitializedEvent();
                    //}, 100);

                    fp.log('Freshop initialized...');

                    delete fp.initializing;
                    fp.initialized = true;
                    freshop.initialized = true;
                    fp.trigger(fp.events.INITIALIZED);
                }
            }

            return deferredInit.promise();
        }
        ,setSession: function(payload, replace) {
            var oldSession = $.extend(true, {}, this.session);
            if(replace) this.session = payload;
            else this.session = $.extend(this.session, payload);

            if(!_.isObject(this.session.preference)) this.session.preference = {};

            //until all in-progress orders are cleared we need to backfill preference
            //**this is causing issues
            //_.each([
            //        'order_step',
            //        'order_id',
            //        'order_store_id',
            //        'order_fulfillment_type_id',
            //        'payment_method',
            //        'saved_payment_method',
            //        'payment_type_id'
            //    ], function(key) {
            //        if(_.has(fp.session, key)) fp.session.preference[key] = fp.session[key];
            //    });

            this.setSessionCookie({
                token: this.session.token
            });

            if(!_.isEqual(this.session, oldSession)) {
                fp.trigger(fp.events.SESSION_CHANGED, {
                    session: this.session,
                    oldSession: oldSession
                });
            }
        }
        ,removeSession: function() {
            var oldToken = this.session.token || this.getSessionCookie().token;

            this.setSessionCookie();

            this.session = {
                preference: {}
            };

            _.empty(fp.cache.authorization);

            var deferred = $.Deferred();

            if (oldToken) {
                fpService.sessionService.delete(oldToken, {
                    ignoreErrors: true
                })
                .always(function (resp) {
                    if(fp.sessionInitialized) fp.initSession().always(deferred.resolve);
                    else deferred.resolve();
                });
            }
            else {
                if(fp.sessionInitialized) fp.initSession().always(deferred.resolve);
                else deferred.resolve();
            }

            return deferred
                .then(function() {
                    fp.log('Session: ', fp.session);
                    return fp.session;
                });
        }
        ,getCookieName: function(cookieName) {
            cookieName = S.getString(cookieName);
            if(window.location.port) {
                var port = '-' + S.getString(window.location.port, '80');
                if (!S(cookieName).endsWith(port)) cookieName += port;
            }
            return cookieName;
        }
        ,getCookie: function(cookieName, sanitizeFn) {
            cookieName = this.getCookieName(cookieName);
            const cookie = _.getObject($.cookie(cookieName)),
                sanitizeRegExp = fpUtil.regExp.matchJsonXssInvalidChars;

            (function sanitize(obj) {
                _.each(obj, function(value, key) {
                    if(_.isString(value)) {
                        sanitizeRegExp.lastIndex = 0;
                        value = value.replace(sanitizeRegExp, '');
                        if(_.isFunction(sanitizeFn)) value = sanitizeFn(value, key);
                        obj[key] = value;
                    }
                    else if(_.isObject(value)) {
                        sanitize(value);
                    }
                });
            })(cookie);

            return cookie;
        }
        ,setCookie: function(cookieName, value, expires) {
            var cookieName = this.getCookieName(cookieName),
                overrideDomain = fpConfig.cookieDomain && fpConfig.cookieDomain !== location.hostname && S(location.hostname).endsWith(fpConfig.cookieDomain),
                cookie,
                domain;

            if(overrideDomain) {
                domain = '.' + fpConfig.cookieDomain;

                //remove cookie that exists where no domain is explicitly set
                $.removeCookie(cookieName, {
                    path: '/',
                    expires: -1
                });
            }

            if(_.isObject(value)) {
                cookie = this.getCookie(cookieName);
                const isArray = _.isArray(value);

                if(isArray && !_.isArray(cookie)) {
                    cookie = [];
                }

                _.each(value, function(item, key) {
                    if(fpUtil.isNull(item)) {
                        if(!isArray) delete cookie[key];
                    }
                    else cookie[key] = item;
                });
                
                //if(S(cookieName).startsWith('fp-pref')) {
                //    fp.logStack('Set: ', cookieName, cookie);
                //}
                //fp.log('Set: ', cookieName, cookie);

                $.cookie(cookieName, cookie, {
                    path: '/',
                    expires: expires || 365,
                    secure: window.location.protocol == 'https:',
                    samesite: 'Lax',
                    domain: domain
                });
            }
            else {
                //fp.log('Remove: ', cookieName);
                $.removeCookie(cookieName, {
                    path: '/',
                    expires: -1,
                    domain: domain
                });

                //remove cookie that may be set at top level domain
                $.removeCookie(cookieName, {
                    path: '/',
                    expires: -1,
                    domain: '.' + location.hostname.split('.').splice(-2).join('.')
                });

                cookie = null;
            }

            return cookie;
        }
        ,getSessionCookie: function() {
            const cookie = this.getCookie('fp-session', function(value, key) {
                //ensure token has valid characters
                if(S(key).startsWith('token') && !_.first(S(value).match(fpUtil.regExp.matchItemId))) {
                    value = undefined;
                }
                return value;
            });
            return cookie;
        }
        ,setSessionCookie: function(value) {
            this.setCookie('fp-session', value);
        }
        ,getPrefCookie: function() {
            const cookie = this.getCookie('fp-pref');
            cookie.debug = _.getObject(cookie.debug);

            return cookie;
        }
        ,setPrefCookie: function(value) {
            if(_.isObject(value) && !_.size(value.debug)) delete value.debug;
            this.setCookie('fp-pref', value);
        }
        ,initLogin: function(options) {
            const pref = {
                referral_code: null
            };

            if(!fpConfig.disableInitializeShopping) {
                if(!pref.store_id && fp.user.selected_store_id) {
                    pref.store_id = fp.user.selected_store_id;
                }
                else if(
                    fp.store.id &&
                    S(fp.store.price_mode_id).ne(fpUtil.map.get('storePriceMode').get('price_required').id)
                ) {
                    //silently unset selected store that does not have price mode
                    pref.store_id = null;
                }
            }

            if(fpConfig.shopIntent.enableAgeGate) fp.setSessionCookie({ageGate: true});

            fp.setPrefCookie(pref);
            _.empty(fp.cache.authorization);

            return fpUi.triggerMfa({intent: 'login'})
                .then(function() {
                    return fp.initSession(false, true)
                        .then(function() {
                            if(fpUtil.isAuthenticated()) {
                                //handle use case where we need to prompt for passkey
                                return fpUi.triggerMfa({intent: 'prompt', mode: 'passkey-prompt', modalDisableClose: true});
                            }
                            return 'cancel';
                        })
                        .done(function(resp) {
                            options = _.getObject(options);

                            var next = resp && resp !== 'cancel' ? null : fpUi.applyUserLocaleToUrl(fpUi.getLoginRedirectUrl(options), ['next']),
                                isCurrentPage = fpUi.router.location.isCurrentPage(next),
                                deferredList,
                                promiseStore;

                            if(isCurrentPage) {
                                if(fp.getSelectedStoreId()) {
                                    //when initializing login ensure that user's selected store is used
                                    promiseStore = fp.getStore(fp.user.selected_store_id);
                                }

                                deferredList = $.Deferred();
                                $.when(promiseStore)
                                    .always(function() {
                                        var initializeShopping = !fpConfig.disableInitializeShopping;

                                        if(fpUtil.isAuthenticated()) {
                                            fp.trigger(fp.events.USER_LOADED, fp.user);
                                            fp.trigger(fp.events.USER_CHANGED, fp.user);

                                            fp.listManager = new fpUi.ListManager();

                                            if(initializeShopping) {
                                                fp.listManager.getSelectedList(true, null, {handleErrors: false})
                                                    .always(function() {
                                                        //need to wait for list to resolve before we trigger store change
                                                        fp.ensureActiveStore(true)
                                                            .done(deferredList.resolve);
                                                    });
                                            }
                                            else deferredList.resolve();
                                        }
                                        else deferredList.resolve();

                                        fp.trigger(fp.events.STORE_CHANGED, (fp.store.id ? fp.store : {}));
                                    });
                            }

                            if(!next) return;

                            $.when(deferredList)
                                .always(function() {
                                    if(isCurrentPage) {
                                        var checkoutUrl = fpConfig.urls.checkout;
                                        if (checkoutUrl && S(next).contains(checkoutUrl, true)) {
                                            fp.trigger(fp.events.LIST_CHECKOUT, {
                                                listManager: fp.listManager,
                                                checkoutUrl: next
                                            });
                                            return;
                                        }
                                    }

                                    fpUi.router.stateManager.go(next, null, {absolute: true, disableRouteParams: options.disableRouteParams});
                                });
                        });
            });
        }
        ,logout: function(next, disableCloseActiveModal) {
            var uiRouter = this.ui.router,
                stateManager = uiRouter.stateManager,
                stateParams = stateManager.initialized ? stateManager.stateParams : uiRouter.routeManager.urlParams,
                kioskStoreId = fp.getPrefCookie().kiosk_store_id,
                oauthLogoutUrl,
                promise

            if(!disableCloseActiveModal) fpUi.closeActiveModal();

            fp.setPrefCookie();
            if(fp.config.enableKiosk) fp.setPrefCookie({kiosk_store_id: kioskStoreId});

            if(history) history.flush();
            Lockr.flush();

            // if(stateParams.oauth_signout !== 'true') {
            //     oauthLogoutUrl = fpUi.getOauthLogoutUrl(stateManager.href(fpConfig.routeStates.logout, {oauth_signout: true}, {absolute: true}));
            // }

            oauthLogoutUrl = fpUi.getOauthLogoutUrl(next);

            if(oauthLogoutUrl) {
                fp.setSessionCookie();
                stateManager.go(oauthLogoutUrl, null, {absolute: true});
            }
            else {
                var oldUserId = this.user.id,
                    history = fpUi.router.stateManager.history,
                    isCurrentPage = fpUi.router.location.isCurrentPage(next),
                    session;
    
                promise = fp.removeSession()
                    .then(function(resp) {
                        session = resp;

                        if(!_.isObject(session.preference)) session.preference = {};

                        fp.setUser(null, isCurrentPage);

                        if(!fp.initialized) return session;

                        //set unloading flag so we can control what happens when store is removed from session
                        //if(next) fp.isUnloading = true;
                        //
                        //return fp.setStore(null, true);
                    })
                    .then(function() {
                        if(S(fp.user.id).ne(oldUserId) && isCurrentPage) {
                            fp.trigger(fp.events.USER_CHANGED, fp.user);
                        }

                        if(next) {
                            fpUi.router.stateManager.go(next, null, {absolute: true, reload: true});
                            //if(fpUi.router.location.isCurrentPage(next)) {
                            //    return $.Deferred().promise();
                            //}
                        }

                        return session;
                    });
            }

            return $.when(promise);
        }
        ,setUser: function(data, isCurrentPage) {
            data = _.getObject(data);

            if(!data.error) {
                if(!_.isObject(data.preference)) data.preference = {};
                this.user = data;
            }

            if(this.user.selected_store_id == '0') delete this.user.selected_store_id;

            if(fpUtil.getBoolean(isCurrentPage, true)) {
                $.when($.ready)
                    .done(function () {
                        $(document.body).toggleClass('fp-is-logged-in', fpUtil.isAuthenticated());
                    });
            }

            if(fp.user.last_used_shopping_list_id && S.getString(this.getSessionCookie().active_list_id, fp.defaultList.id) === fp.defaultList.id) {
                fp.setSessionCookie({active_list_id: fp.user.last_used_shopping_list_id});
            }
        }
        ,getSelectedStoreId: function() {
            // to ensure different session does not change current session's store
            // first attempt to use cookie's store_id then user's selected_store_id
            return this.getPrefCookie().store_id || this.user.selected_store_id;
        }
        ,getStore: function(storeId, storeNumber) {
            if(!storeNumber) storeId = storeId || this.getSelectedStoreId();

            var currentStore = fp.store,
                deferred = $.Deferred();

            if((storeId && storeId != fp.store.id) || (storeNumber && storeNumber != fp.store.number)) {
                const payload = {};
                let promise;
                if(storeId && storeId != fp.store.id) payload.id = storeId;
                else payload.number = storeNumber;

                const selectedStore = fp.cache.selectedStore;
                delete fp.cache.selectedStore;
                if(selectedStore && (payload.id === selectedStore.id || payload.number === selectedStore.number)) {
                    promise = $.Deferred().resolve({items: [selectedStore]}).promise();
                }
                else {
                    promise = fpService.storeService
                        .get(payload, {handleErrors: false});
                }

                promise
                    .done(getStoreSuccess)
                    .fail(getStoreFail);
            }
            else if(!storeId && !fp.store.id && !storeNumber && !fpConfig.disableInitializeShopping) {
                //if store has not been selected, check to see if there is only one store
                //that is flagged for is_selectable if so, set it as the default store
                if(fp.config.disableStoreAutoSelect) {
                    getStoreSuccess();
                }
                else {
                    fpService.storeService
                        .get({
                            is_selectable: true,
                            has_address: true,
                            limit: 1
                        }, {handleErrors: false})
                        .done(function(resp) {
                            if(resp.total != 1) resp = null;
                            getStoreSuccess(resp);
                        })
                        .fail(getStoreFail);
                }
            }
            else getTopStore();

            function getTopStore(topStore) {
                if (!fp.store.id && !storeId) {
                    fp.store = topStore || $.extend(true, {}, fp.topStore);

                    if(!fpConfig.disableInitializeShopping) delete fp.store.id;                    
                }

                fp.setStore(fp.store)
                    .done(function () {
                        deferred.resolve(fp.store);
                    });
            }

            function getStoreSuccess(resp) {
                // var store = resp ? _.first(resp.items) : null;
                //temp fix for api issue
                var store;
                if(resp) {
                    if(storeId) store = _.findWhere(resp.items, {id: storeId});
                    else if(storeNumber) store = _.findWhere(resp.items, {number: storeNumber});

                    if(!store) {
                        store = _.first(resp.items);
                        if(storeId) {
                            storeId = null;
                            fp.setPrefCookie({store_id: null});
                        }
                    }
                }

                if(!_.isObject(store)) {
                    var topStore;
                    //if the store that errored is user's selected store we need to force clear it
                    if(storeId && storeId == fp.user.selected_store_id) {
                        topStore = {error: true};
                    }
                    storeId = null;
                    fp.setPrefCookie({store_id: null});

                    getTopStore(topStore);
                    return;
                }

                if(currentStore == store) {
                    deferred.resolve(fp.store);
                    return;
                }

                fp.setStore(store).done(function () {
                    deferred.resolve(fp.store);
                });
            }

            function getStoreFail(jqXHR, textStatus, errorThrown) {
                var resp = fpUtil.getXhrErrorResponse(jqXHR),
                    httpStatus = fpConstants.httpStatus,
                    status = resp.status_code || jqXHR.status || '';

                if (status == httpStatus.BAD_REQUEST) {
                    getStoreSuccess();
                    return;
                }

                fpUtil.handleApiError(resp, textStatus, jqXHR);
            }

            return deferred.promise();
        }
        ,setStore: function(data, force) {
            var promiseFallback;

            if(!_.isObject(data)){
                data = $.extend(true, {}, fp.topStore);
                delete data.id;
            }

            if(!force && !fpConfig.disableInitializeShopping && !data.error && (!data.id || !data.is_selectable)) {
                var fallbackStoreId = fp.getSelectedStoreId();
                if (fallbackStoreId && fallbackStoreId != data.id) {
                    var priceRequiredId = S(fpUtil.map.get('storePriceMode').get('price_required').id),
                        hasPriceRequired = priceRequiredId.eq(data.price_mode_id);

                    if (!hasPriceRequired) {
                        promiseFallback = fpService.storeService
                            .get({
                                id: fallbackStoreId
                            }, {handleErrors: false})
                            .then(function (resp) {
                                resp = _.first(resp.items);
                                if (resp && !resp.error && resp.is_selectable && priceRequiredId.eq(resp.price_mode_id)) {
                                    data = resp;
                                }
                            });
                    }
                }
                else {
                    data = $.extend(true, {}, fp.topStore);
                    delete data.id;
                }
            }

            return $.when(promiseFallback)
                .then(function() {
                    let isStoreChanged = false,
                        promise,
                        setUserError;

                    if(!data.error && (!data.id || data.is_selectable)) {
                        isStoreChanged = S(data.id).ne(fp.store.id);
                        fp.store = data;
                    }

                    if (!fpConfig.disableInitializeShopping) {
                        let activeStoreId = fp.getSessionCookie().active_store_id;

                        if (fpUtil.isAuthenticated() && !activeStoreId && S(fp.user.selected_store_id).ne(fp.store.id)) {
                            let payload = {},
                                ignoreErrors = ['invalid_input', 'store_card_required'];

                            // user selected store would not be updated in kiosk
                            if(!fp.config.enableKiosk){
                                if (fp.store.id) payload.selected_store_id = fp.store.id;
                                else payload.selected_store_id_clear = true;
                            }

                            promise = fpService.userMeService
                                .update(payload, {ignoreErrors: ignoreErrors})
                                .done(function(resp) {
                                    fp.setUser(resp);
                                })
                                .fail(function(jqXHR, textStatus, error) {
                                    let resp = fpUtil.getXhrErrorResponse(jqXHR);
                                    if(!_.contains(ignoreErrors, resp.error_code)) return;

                                    if (fp.store.id) fp.user.selected_store_id = fp.store.id;
                                    else delete fp.user.selected_store_id;

                                    fp.setUser(fp.user);

                                    setUserError = resp.error_message;
                                });
                        }
                        else if (activeStoreId && S(fp.user.selected_store_id).eq(fp.store.id)) {
                            fp.setSessionCookie({active_store_id: null});
                        }

                        if(isStoreChanged) {
                            promise = $.when(promise)
                                .then(function() {
                                    return fp.ensureStoreOtherAttributes(fp.store);
                                })
                                .then(function() {
                                    return fpUi.initSiteUrls();
                                });

                            if(!fpConfig.enableLocaleRoute) {
                                promise = promise
                                    .done(function () {
                                        let shoppingUrlPath = fpUi.getSiteUrls().shopping_url_path,
                                            routeDelimiter = fpUtil.formatString('{0}{1}/', S().trailingSlashIt().s, fp.routeDelimiter);

                                        if (shoppingUrlPath && S(fpConfig.routeStates.product.url).trimRight(routeDelimiter).ne(shoppingUrlPath)) {
                                            let stateManager = fpUi.router.stateManager,
                                                productState = fpConfig.routeStates.product;

                                            productState.url = fpUtil.formatString('{0}{1}', S(shoppingUrlPath).ensureLeft('/').s, routeDelimiter);
                                            stateManager.rebuildState(fpConfig.routeStates.product);
                                        }
                                    });
                            }

                            if(fp.loaded) {
                                promise = promise
                                    .then(onStoreBeforeChange, onStoreBeforeChange);

                                function onStoreBeforeChange() {
                                    let promises = [],
                                        payload = {
                                            store: fp.store,
                                            clientParams: {
                                                promises: promises
                                            }
                                        };

                                    fp.trigger(fp.events.STORE_BEFORE_CHANGE, payload);

                                    return $.when.apply($, promises);
                                }
                            }
                        }
                    }

                    return $.when(promise)
                        .always(function() {
                            if(!fpConfig.disableInitializeShopping/* && S(fpUtil.map.get('storePriceMode').get('price_required').id).eq(fp.store.price_mode_id)*/) {
                                fp.setPrefCookie({store_id: fp.store.id});
                            }

                            // var hashedFulfillmentTypes = {};
                            // _.each(fp.store.fulfillment_types, function(item) {
                            //     hashedFulfillmentTypes[item.id] = item;
                            //     hashedFulfillmentTypes[item.identifier] = item;
                            // });
                            // fp.store.hashedFulfillmentTypes = hashedFulfillmentTypes;

                            let stateManager = fpUi.router.stateManager;
                            if(fp.loaded && isStoreChanged) {
                                let redirectUrl = fpUi.getSiteUrls().make_this_my_store_url;
                                if(redirectUrl && !setUserError && !stateManager.stateParams.next && !fpUi.router.location.isCurrentPage(redirectUrl)) {
                                    stateManager.go(redirectUrl, null, {absolute: true});
                                }
                                else {
                                    fp.trigger(fp.events.STORE_CHANGED, fp.store);
                                }
                            }

                            if(setUserError) {
                                stateManager.go(fpConfig.routeStates.account, {error: setUserError});
                            }
                        });
                });
        },
        ensureStoreOtherAttributes: function(store) {
            //if store.other_attributes contains related_catering_store_id and/or related_wine_store_id
            //make store api calls to ensure those stores exist, if store does not exist remove the attributes
            const deferred = $.Deferred();
            if(_.size(store?.other_attributes)) {
                if(store.other_attributes.related_shopping_id === store.id) {
                    delete store.other_attributes.related_shopping_id;
                }

                const hashedRelatedIds = {
                        related_catering_store_id: '',
                        related_wine_store_id: ''
                    },
                    storeIds = [];
                    
                let hashedStores;

                fp.cache.hashedRelatedStores = _.getObject(fp.cache.hashedRelatedStores);
                _.each(hashedRelatedIds, function(value, key) {
                    const relatedId = store.other_attributes[key];
                    if(relatedId && !fp.cache.hashedRelatedStores[relatedId]) {
                        hashedRelatedIds[key] = relatedId;
                        storeIds.push(relatedId);
                    }
                });

                if(storeIds.length) {
                    fpService.storeService
                        .get({
                            id: storeIds
                        }, {
                            ignoreErrors: true
                        })
                        .then(function(resp) {
                            hashedStores = _.indexBy(resp.items, 'id');
                        })
                        .always(function() {
                            hashedStores = _.getObject(hashedStores);
                            _.each(hashedRelatedIds, function(value, key) {
                                fp.cache.hashedRelatedStores[value] = hashedStores[value];
                                if(value && !hashedStores[key]) {
                                    store.other_attributes[`__${key}`] = value;
                                    delete store.other_attributes[key];
                                }
                            });
                            deferred.resolve(store);
                        });
                }
                else {
                    deferred.resolve(store);
                }
            }
            else {
                deferred.resolve(store);
            }
            return deferred.promise();
        }
    });
})();
